// Define validators
export const validators = {
  required: (value) => (Array.isArray(value) ? value.length > 0 : !!value) || "This field is required",
  email: (value) =>
    !value || /.+@.+\..+/.test(value) || "Please enter a valid email address",
  phone_number: (value) =>
    !value || /^(?:\+?\d{1,3}[-.\s]?)?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/.test(value) ||
    "Please enter a valid phone number",
};

// Validate all rows before saving
export const validateRows = (rows, columns) => {
  let isValid = true;
  const invalidFields = [];

  rows.forEach((row, rowIndex) => {
    columns.forEach((col) => {
      if (!col.validation) return; // skip if no validation

      // col.validation can be a string or array
      const rules = Array.isArray(col.validation) ? col.validation : [col.validation];

      for (let rule of rules) {
        const result = validators[rule](row[col.key]);
        if (result !== true) {
          isValid = false;
          invalidFields.push({ row: rowIndex, key: col.key, message: result });
          break; // stop at first failing rule
        }
      }
    });
  });
  return { isValid, invalidFields };
};